let dismissListener = null;

const removeDismissListener = () => {
    if (dismissListener === null) {
        return;
    }

    document.removeEventListener('click', dismissListener);
    dismissListener = null;
};

const clearInlineConfirmations = (except = null) => {
    document.querySelectorAll('[data-inline-confirm].confirming').forEach((button) => {
        if (button === except) {
            return;
        }

        button.classList.remove('confirming');

        if ('inlineConfirmOriginalLabel' in button.dataset) {
            button.setAttribute('aria-label', button.dataset.inlineConfirmOriginalLabel);
            delete button.dataset.inlineConfirmOriginalLabel;
        }
    });

    if (except === null) {
        removeDismissListener();
    }
};

const registerDismissListener = () => {
    if (dismissListener !== null) {
        return;
    }

    dismissListener = (event) => {
        if (event.target.closest('[data-inline-confirm].confirming')) {
            return;
        }

        clearInlineConfirmations();
    };

    document.addEventListener('click', dismissListener);
};

export const handleInlineConfirm = (button) => {
    if (button.classList.contains('confirming')) {
        clearInlineConfirmations();
        button.dispatchEvent(new CustomEvent('confirmed', {bubbles: true}));

        return;
    }

    clearInlineConfirmations(button);

    button.dataset.inlineConfirmOriginalLabel = button.getAttribute('aria-label') ?? '';
    button.setAttribute('aria-label', button.dataset.inlineConfirmLabel);
    button.classList.add('confirming');

    registerDismissListener();
};
